import { createFileRoute } from "@tanstack/react-router";
import { FingerspellingDrillPage } from "../../components/fingerspelling/FingerspellingDrillPage";

export const Route = createFileRoute("/_app/fingerspelling_/drill")({
  component: FingerspellingDrillPage,
});
